var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "container" },
    [
      _c(
        "div",
        { staticClass: "info" },
        _vm._l(_vm.infos, function (item, index) {
          return _c("div", { key: index, staticClass: "info-item" }, [
            _c("div", { staticStyle: { padding: "24px 32px" } }, [
              _c("div", { staticClass: "title" }, [_vm._v(_vm._s(item.title))]),
              _c("div", { staticClass: "num" }, [_vm._v(_vm._s(item.num))]),
            ]),
            index < _vm.infos.length - 1
              ? _c("div", { staticClass: "line" })
              : _vm._e(),
          ])
        }),
        0
      ),
      _c(
        "div",
        { staticClass: "content" },
        [
          _c(
            "el-form",
            {
              ref: "searchForm",
              staticClass: "search-form",
              attrs: {
                inline: true,
                model: _vm.searchForm,
                size: "small",
                "label-width": "64px",
              },
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "应聘岗位" } },
                [
                  _c(
                    "el-select",
                    {
                      attrs: { placeholder: "请选择", clearable: "" },
                      model: {
                        value: _vm.searchForm.recruitPost,
                        callback: function ($$v) {
                          _vm.$set(_vm.searchForm, "recruitPost", $$v)
                        },
                        expression: "searchForm.recruitPost",
                      },
                    },
                    _vm._l(_vm.dictionaries.recruit_post, function (item) {
                      return _c("el-option", {
                        key: item.dictId,
                        attrs: { label: item.dictName, value: item.dictId },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  attrs: { label: "应聘者姓名" },
                  scopedSlots: _vm._u([
                    {
                      key: "label",
                      fn: function () {
                        return [
                          _c(
                            "div",
                            {
                              staticStyle: {
                                width: "64px",
                                display: "flex",
                                "justify-content": "space-between",
                                "box-sizing": "border-box",
                                "padding-right": "8px",
                                "flex-direction": "column",
                                "line-height": "16px",
                              },
                            },
                            [
                              _c("div", [_vm._v("应聘者")]),
                              _c("div", [_vm._v("姓名")]),
                            ]
                          ),
                        ]
                      },
                      proxy: true,
                    },
                  ]),
                },
                [
                  _c("el-input", {
                    attrs: { placeholder: "请输入", clearable: "" },
                    model: {
                      value: _vm.searchForm.name,
                      callback: function ($$v) {
                        _vm.$set(_vm.searchForm, "name", $$v)
                      },
                      expression: "searchForm.name",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "应聘阶段" } },
                [
                  _c(
                    "el-select",
                    {
                      attrs: { placeholder: "请选择", clearable: "" },
                      model: {
                        value: _vm.searchForm.status,
                        callback: function ($$v) {
                          _vm.$set(_vm.searchForm, "status", $$v)
                        },
                        expression: "searchForm.status",
                      },
                    },
                    _vm._l(_vm.dictionaries.recruit_status, function (item) {
                      return _c("el-option", {
                        key: item.dictId,
                        attrs: { label: item.dictName, value: item.dictId },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "应聘部门", prop: "name" } },
                [
                  _c(
                    "el-select",
                    {
                      attrs: { placeholder: "请选择", clearable: "" },
                      model: {
                        value: _vm.searchForm.orgName,
                        callback: function ($$v) {
                          _vm.$set(_vm.searchForm, "orgName", $$v)
                        },
                        expression: "searchForm.orgName",
                      },
                    },
                    _vm._l(_vm.positions, function (item) {
                      return _c("el-option", {
                        key: item.orgCode,
                        attrs: { label: item.orgName, value: item.orgName },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "应聘日期" } },
                [
                  _c("eldate", {
                    attrs: { dateData: _vm.applyTime },
                    on: {
                      changeData: function ($event) {
                        return _vm.changeData($event)
                      },
                    },
                  }),
                ],
                1
              ),
              _c("el-form-item", [
                _c("div", { staticStyle: { display: "flex" } }, [
                  _c(
                    "div",
                    {
                      staticClass: "s-btn",
                      on: {
                        click: function ($event) {
                          return _vm.fetchData("search")
                        },
                      },
                    },
                    [_vm._v("查询")]
                  ),
                  _c(
                    "div",
                    {
                      staticClass: "r-btn",
                      on: {
                        click: function ($event) {
                          return _vm.fetchData("reset")
                        },
                      },
                    },
                    [_vm._v("重置")]
                  ),
                ]),
              ]),
            ],
            1
          ),
          _c("div", { staticClass: "line" }),
          _c("div", { staticClass: "data-title" }, [
            _vm._m(0),
            _c("div", { staticClass: "title-btn" }, [
              _c(
                "div",
                {
                  staticClass: "title-btn-item",
                  staticStyle: { "margin-right": "12px" },
                  on: {
                    click: function ($event) {
                      return _vm.deliverData()
                    },
                  },
                },
                [
                  _c("img", {
                    staticStyle: { width: "16px", height: "16px" },
                    attrs: { src: require("../../../assets/icon_daochu.png") },
                  }),
                  _c("div", { staticClass: "btn-l" }, [_vm._v("导出列表")]),
                ]
              ),
              _c(
                "div",
                {
                  staticClass: "title-btn-item",
                  staticStyle: { "margin-right": "12px" },
                  on: {
                    click: function ($event) {
                      return _vm.alotPrint()
                    },
                  },
                },
                [
                  _c("img", {
                    staticStyle: { width: "16px", height: "16px" },
                    attrs: { src: require("../../../assets/icon_dayin.png") },
                  }),
                  _c("div", { staticClass: "btn-l" }, [_vm._v("批量打印")]),
                ]
              ),
              _c(
                "div",
                { staticClass: "title-btn-item", on: { click: _vm.add } },
                [
                  _c("i", { staticClass: "el-icon-plus" }),
                  _c("div", { staticClass: "btn-l" }, [_vm._v("新增应聘信息")]),
                ]
              ),
            ]),
          ]),
          _c("lb-table", {
            directives: [
              {
                name: "horizontal-scroll",
                rawName: "v-horizontal-scroll",
                value: "always",
                expression: "'always'",
              },
            ],
            attrs: {
              column: _vm.columns,
              data: _vm.list,
              pagination: "",
              total: _vm.totalNum,
              layout: "total, sizes, prev, pager, next, jumper",
              "page-sizes": [5, 10, 20, 30, 50, 200, 2000],
              "current-page": _vm.page.pageNo,
              "page-size": _vm.page.pageSize,
            },
            on: {
              "update:currentPage": function ($event) {
                return _vm.$set(_vm.page, "pageNo", $event)
              },
              "update:current-page": function ($event) {
                return _vm.$set(_vm.page, "pageNo", $event)
              },
              "selection-change": _vm.onMultipleSelection,
              "size-change": _vm.handleSizeChange,
              "p-current-change": _vm.handleCurrentChange,
            },
          }),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "提示",
            visible: _vm.isConfirm,
            width: "268px",
            "append-to-body": "",
          },
          on: {
            "update:visible": function ($event) {
              _vm.isConfirm = $event
            },
          },
        },
        [
          _c(
            "div",
            {
              staticStyle: {
                "font-size": "14px",
                color: "#2F3030",
                "line-height": "22px",
                "text-align": "center",
                "margin-left": "12px",
              },
            },
            [
              _vm._v(
                " 是否确认把该应聘者标记为“" + _vm._s(_vm.statusLabel) + "”？"
              ),
            ]
          ),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.isConfirm = false
                    },
                  },
                },
                [_vm._v("取 消")]
              ),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: {
                    click: function ($event) {
                      return _vm.changeStatus()
                    },
                  },
                },
                [_vm._v("确认")]
              ),
            ],
            1
          ),
        ]
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "备注",
            visible: _vm.isRemark,
            width: "552px",
            "append-to-body": "",
          },
          on: {
            "update:visible": function ($event) {
              _vm.isRemark = $event
            },
          },
        },
        [
          _c("div", { staticClass: "dialog-body" }, [
            _c(
              "div",
              { staticClass: "dialog-title" },
              [
                _c(
                  "el-form",
                  {
                    ref: "form",
                    staticClass: "form",
                    staticStyle: { width: "100%" },
                    attrs: {
                      inline: true,
                      model: _vm.form,
                      size: "small",
                      "label-width": "82px",
                      rules: _vm.rules,
                    },
                  },
                  [
                    _c(
                      "el-form-item",
                      {
                        staticStyle: { "margin-left": "20px" },
                        attrs: { label: "备注" },
                        scopedSlots: _vm._u([
                          {
                            key: "label",
                            fn: function () {
                              return [
                                _c(
                                  "div",
                                  { staticStyle: { "line-height": "18px" } },
                                  [
                                    _c(
                                      "span",
                                      {
                                        staticStyle: {
                                          color: "#F56C6C",
                                          "margin-right": "4px",
                                        },
                                      },
                                      [_vm._v("*")]
                                    ),
                                    _vm._v("备注 "),
                                  ]
                                ),
                              ]
                            },
                            proxy: true,
                          },
                        ]),
                      },
                      [
                        _c("el-input", {
                          staticStyle: { width: "306px" },
                          attrs: {
                            placeholder: "请输入",
                            maxlength: "24",
                            type: "textarea",
                            "show-word-limit": "",
                            rows: "3",
                          },
                          model: {
                            value: _vm.form.remark,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "remark", $$v)
                            },
                            expression: "form.remark",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
          ]),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.isRemark = false
                    },
                  },
                },
                [_vm._v("取 消")]
              ),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: {
                    click: function ($event) {
                      return _vm.submitRemark()
                    },
                  },
                },
                [_vm._v("确认")]
              ),
            ],
            1
          ),
        ]
      ),
      _c(
        "div",
        {
          staticStyle: { width: "0", height: "0" },
          attrs: { id: "print-content" },
        },
        [
          _c(
            "div",
            { staticClass: "pop-up-content1" },
            [
              _c("base-staff-record-detail-print", {
                attrs: { currentRow: _vm.currentRow },
              }),
            ],
            1
          ),
        ]
      ),
      _c(
        "div",
        { staticStyle: { display: "none" }, attrs: { id: "print-content1" } },
        [
          _c("base-staff-record-detail", {
            attrs: { currentRow: _vm.currentRow, row: _vm.row1 },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticStyle: { display: "flex", height: "32px" } }, [
      _c("div", { staticClass: "title-line" }),
      _c("div", { staticClass: "title-name" }, [_vm._v("数据列表")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }